/* eslint-disable @typescript-eslint/camelcase */
import { isEmpty } from 'lodash'
import { IPriceConfiguration } from '../index'

export default function(values: IPriceConfiguration, objectId, calendarId) {
  return {
    id_calendar: calendarId,
    id_object: objectId,
    kids: values.kidsPrice
      ? values.kids
        .map(kid => {
          return (kid.ageTo !== undefined && kid.ageFrom !== undefined) ||
          kid.deleted
            ? {
              age_from: Number(kid.ageFrom),
              age_to: Number(kid.ageTo),
              deleted: kid.deleted,
              food_discount: 0,
              id: Number(kid.id) ? Number(kid.id) : undefined,
            }
            : {}
        })
        .filter(item => !isEmpty(item))
      : isEmpty(values.kids[0])
        ? []
        : values.kids
          .map(kid => {
            return kid.ageTo !== undefined && kid.ageFrom !== undefined
              ? {
                age_from: Number(kid.ageFrom),
                age_to: Number(kid.ageTo),
                deleted: 1,
                food_discount: 0,
                id: Number(kid.id) ? Number(kid.id) : undefined,
              }
              : {}
          })
          .filter(item => !isEmpty(item)),
  }
}
